import React, { Component } from "react";
import { EkoFormDate, EkoFormInputText, EkoFormSelect } from "../../components/elements/EkoForm";
import Api from "../../util/Api";
import { toastr } from "react-redux-toastr";
import Util from "../../util/Util";
import EkoButtonOutline from "../../components/forms/EkoButtonOutline";
import EkoInputTableButtonGroup from "../../components/elements/EkoInputTableButtonGroup";
import ModalDriverInfo from "./ModalDriverInfo";
import ModalLicenseInfo from "./ModalLicenseInfo";

class TransportationContractAddUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = this.defaultData;
  }

  componentWillMount() {
    const id = this.props.params && this.props.params.id;
    if (id) {
      this.setState({ isUpdate: true });
      Api.get("/transportationContract/show/" + id, (response, err) => {
        if (response && response.status === "ok") {
          const lines = Array.isArray(response.lines) ? response.lines : [];
          const contract = response.transportationContract || {};
          this.setState({
            transportationContract: contract,
            rows: lines.length > 0 ? lines : this.state.rows,
            driverRows:
              contract &&
              ((contract.driverRows && contract.driverRows.rows && contract.driverRows.rows.length > 0
                ? contract.driverRows
                : null) ||
                (contract.driver && contract.driver.rows && contract.driver.rows.length > 0
                  ? contract.driver
                  : null))
                ? (contract.driverRows && contract.driverRows.rows && contract.driverRows.rows.length > 0
                    ? contract.driverRows
                    : contract.driver)
                : this.state.driverRows,
            licenseRows:
              contract &&
              ((contract.licenseRows &&
                contract.licenseRows.rows &&
                contract.licenseRows.rows.length > 0
                ? contract.licenseRows
                : null) ||
                (contract.license &&
                  contract.license.rows &&
                  contract.license.rows.length > 0
                  ? contract.license
                  : null))
                ? (contract.licenseRows &&
                    contract.licenseRows.rows &&
                    contract.licenseRows.rows.length > 0
                    ? contract.licenseRows
                    : contract.license)
                : this.state.licenseRows,
          });
        } else {
          toastr.error("Hata", "Bu kayıt görüntülenemiyor");
          this.props.router.push("/dashboard/salesInvoice/transportationContract");
        }
      });
    }
  }

  componentDidMount() {
    Api.get("/customer/list", (res, err) => {
      if (!err) {
        const customers = Array.isArray(res && res.customers)
          ? res.customers.map((c) => ({
              ...c,
              name: c.name || c.fullname || c.title || "",
            }))
          : [];
        this.setState({ customers });
      }
    });

    if (!(this.props.params && this.props.params.id)) {
      Api.get("/transportationContract/lastOrderNumber", (res, err) => {
        if (err) return;
        const last = parseInt(res && res.order_no, 10);
        const nextOrderNo = Number.isFinite(last) ? last + 1 : 1;
        const current = this.state.transportationContract || {};
        if (current.order_no) return;
        this.setState({
          transportationContract: {
            ...current,
            order_no: nextOrderNo,
          },
        });
      });
    }
  }

  get defaultData() {
    return {
      customers: [],
      transportationContract: {},
      rows: [{}],
      errors: { rows: [] },
      error: {},
      saving: false,
      isUpdate: false,
      driverModal: false,
      licenseModal: false,
      driverRows: {
        rows: [
          {
            id: null,
            full_name: "",
            license_no: "",
            issue_place_date: "",
            address: "",
            home_phone: "",
            mobile_phone: "",
          },
        ],
      },
      licenseRows: {
        rows: [
          {
            id: null,
            plate_no: "",
            registration_no: "",
            brand_model: "",
            tax_office_no: "",
            owner_address: "",
            owner_phone: "",
          },
        ],
      },
    };
  }

  get row() {
    return [
      {
        label: "",
        placeholder: "Emtianın Cinsi / Adedi",
        type: "text",
        colMd: 12,
        id: "goods_description",
        vertical: true,
      },
      {
        label: "",
        placeholder: "Kilosu",
        type: "money",
        precision: 3,
        colMd: 12,
        id: "kilos",
        vertical: true,
      },
      {
        label: "",
        placeholder: "Gittiği Yer",
        type: "text",
        colMd: 12,
        id: "destination",
        vertical: true,
      },
    ];
  }

  onFieldChange = (field, value) => {
    const currentError = this.state.error || {};
    const nextError =
      field === "customer_id" && currentError && currentError.customer_id
        ? { ...currentError, customer_id: undefined }
        : currentError;
    this.setState({
      transportationContract: {
        ...this.state.transportationContract,
        [field]: value,
      },
      error: nextError,
    });
  };

  onMount = () => {};

  openDriverModal = () => this.setState({ driverModal: true });
  closeDriverModal = () => this.setState({ driverModal: false });
  saveDriver = (data) => this.setState({ driverRows: data });

  openLicenseModal = () => this.setState({ licenseModal: true });
  closeLicenseModal = () => this.setState({ licenseModal: false });
  saveLicense = (data) => this.setState({ licenseRows: data });

  onRowAdd = () => {};

  onSave = () => {
    const header = { ...this.state.transportationContract };
    if (!header.customer_id) {
      this.setState({ error: { customer_id: ["Müşteri zorunludur"] } });
      return;
    }
    this.setState({ saving: true });
    if (this.state.isUpdate) {
      header.id = this.props.params.id;
    }
    header.driver = this.state.driverRows;
    header.license = this.state.licenseRows;

    const rows = [];
    (this.state.rows || []).forEach((e) => {
      if (!e) return;
      const goods_description = e.goods_description || "";
      const destination = e.destination || "";
      const kilos = Util.convertMoneyToDecimal(e.kilos || 0);
      if (goods_description === "" && destination === "" && (!kilos || kilos === 0)) return;
      rows.push({
        id: this.state.isUpdate ? e.id : null,
        goods_description,
        kilos,
        destination,
      });
    });

    const data = { header, rows };
    const request = this.state.isUpdate ? Api.put : Api.post;
    request("/transportationContract", data, (res) => {
      if (res && res.status === "ok") {
        toastr.success("Başarılı", res.message || "Kaydedildi");
        this.props.router.push("/dashboard/salesInvoice/transportationContract");
      } else if (res && res.status === "row_validation") {
        this.setState({ errors: { rows: res.message }, saving: false });
        return;
      } else if (res && res.status === "header_validation") {
        this.setState({ error: res.message, saving: false });
        return;
      } else {
        toastr.error("Hata", (res && res.message) || "Kaydedilemedi");
      }
      this.setState({ saving: false });
    });
  };

  goBack = () => {
    this.props.router.push("/dashboard/salesInvoice/transportationContract");
  };

  onChange = ({ rows }) => {
    this.setState({ rows });
  };

  render() {
    const driverInfo =
      this.state.driverRows && this.state.driverRows.rows
        ? this.state.driverRows.rows[0] || {}
        : {};
    const licenseInfo =
      this.state.licenseRows && this.state.licenseRows.rows
        ? this.state.licenseRows.rows[0] || {}
        : {};

    const inputProps = {
      onChange: this.onFieldChange.bind(this),
      onMount: this.onMount.bind(this),
      formData: this.state.transportationContract,
      errors: this.state.error,
    };

    return (
      <div>
        <a
          style={{ bottom: "6px", position: "relative", color: "grey" }}
          onClick={Util.backButton.bind(this, "/dashboard/salesInvoice/transportationContract")}
        >
          <i className="fa fa-arrow-left" /> Geri Dön
        </a>

        <div className="portlet light" style={{ paddingBottom: 100 }}>
          <div className="portlet-title">
            <div className="caption font-dark">
              <span className="caption-subject bold uppercase">Taşıma Sözleşmesi</span>
            </div>
          </div>
          <div className="portlet-body">
            <div
              style={{
                padding: "15px 20px",
                background: "#f9fafb",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                border: "1px solid #eef1f4",
                borderRadius: 6,
              }}
            >
              <div className="row">
                <div className="col-md-6">
                  <EkoFormSelect
                    searchable={true}
                    isVertical={true}
                    {...inputProps}
                    id={"customer_id"}
                    defaultText={"Seçiniz"}
                    optionId={"id"}
                    options={this.state.customers}
                    optionValue={"name"}
                  label={"Müşteri *"}
                  />
                </div>
                <div className="col-md-2">
                  <EkoFormInputText
                    {...inputProps}
                    id={"order_no"}
                    type="number"
                    isVertical={true}
                    disabled={this.state.isUpdate}
                    label={"Sıra No"}
                  />
                </div>
                <div className="col-md-2">
                  <EkoFormDate
                    {...inputProps}
                    id={"date"}
                    dateFormat="DD-MM-YYYY"
                    isVertical={true}
                    clearable
                    label={"Düzenleme Tarihi"}
                  />
                </div>
                <div className="col-md-2">
                  <EkoFormInputText
                    {...inputProps}
                    id={"freight"}
                    type="text"
                    isVertical={true}
                    label={"Navlun (Kg / Komple)"}
                  />
                </div>
              </div>

              <div className="row" style={{ marginTop: 10 }}>
                <div className="col-md-3">
                  <EkoButtonOutline
                    buttonProps={{ style: { width: "100%" } }}
                    onClick={this.openLicenseModal}
                    label={"Ruhsat Bilgileri"}
                  />
                  <div style={{ fontSize: 11, color: "#666", marginTop: 6 }}>
                    {licenseInfo.plate_no ? `Plaka: ${licenseInfo.plate_no}` : "—"}
                  </div>
                </div>
                <div className="col-md-3">
                  <EkoButtonOutline
                    buttonProps={{ style: { width: "100%" } }}
                    onClick={this.openDriverModal}
                    label={"Şoför Bilgileri"}
                  />
                  <div style={{ fontSize: 11, color: "#666", marginTop: 6 }}>
                    {driverInfo.full_name ? driverInfo.full_name : "—"}
                  </div>
                </div>
                <div className="col-md-6">
                  <EkoFormInputText
                    {...inputProps}
                    id={"note"}
                    type="textarea"
                    rows={3}
                    isVertical={true}
                    placeHolder={"Not"}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 12,
                padding: "15px 20px",
                background: "#fff",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                border: "1px solid #eef1f4",
                borderRadius: 6,
              }}
            >
              <EkoInputTableButtonGroup
                orderNumber={true}
                onSave={this.onSave}
                onCancel={this.goBack}
                saving={this.state.saving}
                onChange={this.onChange}
                onRowAdd={this.onRowAdd}
                errors={this.state.errors}
                formData={this.state}
                buttonSaveLabel={"Kaydet"}
                data={{
                  headers: [
                    { label: "Emtianın Cinsi / Adedi", width: "45%" },
                    { label: "Kilosu", width: "20%" },
                    { label: "Gittiği Yer", width: "35%" },
                  ],
                  rows: (this.state.rows || []).map((row) => {
                    if (row && row.length !== undefined) return row;
                    return this.row;
                  }),
                }}
              />
            </div>
          </div>
        </div>

        <ModalDriverInfo
          driverRows={this.state.driverRows}
          saveDriver={this.saveDriver}
          showModal={this.state.driverModal}
          closeModal={this.closeDriverModal}
        />
        <ModalLicenseInfo
          licenseRows={this.state.licenseRows}
          saveLicense={this.saveLicense}
          showModal={this.state.licenseModal}
          closeModal={this.closeLicenseModal}
        />
      </div>
    );
  }
}

export default TransportationContractAddUpdate;
